import Model from '../../ModelBinding/Model';
import MissionMediaMetaCollection from './MissionMediaMetaCollection';
import dayjs from 'dayjs';

export default class MissionMediaMeta extends Model {

  public key?: String;
  public origin?: String;
  public value?: String;
  public read_only?: Boolean;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.key = this.getStringAttribute('key');
    this.origin = this.getStringAttribute('origin');
    this.value = this.getStringAttribute('value');
    this.read_only = this.getBooleanAttribute('read_only');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
  }

  static getCollection() {
    return MissionMediaMetaCollection;
  }

}
